/*
  PulloraX - 22 Sept 2026 extras. See assets/pullorax-extras.css for the list.
  Data comes only from live Shopify endpoints and real inventory - nothing is invented.
  Loaded by snippets/pullorax-extras-data.liquid.
*/
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script) return;
  var ds = script.dataset;
  var template = (ds.template || '').toLowerCase();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];

  var T = {
    it: { cart: 'Carrello', rv: 'Visti di recente', cmp: 'Da abbinare', low: 'Solo {n} disponibili', low1: 'Ultimo pezzo disponibile' },
    he: { cart: '\u05e2\u05d2\u05dc\u05d4', rv: '\u05e6\u05e4\u05d9\u05ea\u05dd \u05dc\u05d0\u05d7\u05e8\u05d5\u05e0\u05d4', cmp: '\u05de\u05e9\u05ea\u05dc\u05d1 \u05de\u05e6\u05d5\u05d9\u05df \u05e2\u05dd', low: '\u05e0\u05d5\u05ea\u05e8\u05d5 \u05e8\u05e7 {n} \u05d1\u05de\u05dc\u05d0\u05d9', low1: '\u05e0\u05d5\u05ea\u05e8\u05d4 \u05d9\u05d7\u05d9\u05d3\u05d4 \u05d0\u05d7\u05e8\u05d5\u05e0\u05d4 \u05d1\u05de\u05dc\u05d0\u05d9' },
    fr: { cart: 'Panier', rv: 'Vus r\u00e9cemment', cmp: 'Se marie bien avec', low: 'Plus que {n} en stock', low1: 'Plus qu\u2019un seul en stock' },
    de: { cart: 'Warenkorb', rv: 'Zuletzt angesehen', cmp: 'Passt gut dazu', low: 'Nur noch {n} auf Lager', low1: 'Nur noch 1 auf Lager' },
    /* 16 Oct 2026: Spanish was missing here, so es pages showed these four lines in English. */
    es: { cart: 'Carrito', rv: 'Vistos recientemente', cmp: 'Combina bien con', low: 'Solo quedan {n} en stock', low1: 'Solo queda 1 en stock' },
    en: { cart: 'Cart', rv: 'Recently viewed', cmp: 'Goes well with', low: 'Only {n} left in stock', low1: 'Only 1 left in stock' }
  };
  var L = T[lang] || T.en;
  var X = window.PXT;
  if (X) L = { cart: X.cart || L.cart, rv: X.recently_viewed || L.rv, cmp: X.goes_well_with || L.cmp, low: X.only_n_left || L.low, low1: X.only_1_left || L.low1 };

  function money(cents) {
    var n = Number(cents) / 100;
    var fmt = ds.moneyFormat || '';
    var num = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (/\{\{\s*amount\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*amount\s*\}\}/, num);
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: document.documentElement.getAttribute('data-px-currency') || 'USD' }).format(n);
    } catch (e) { return num; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchProduct(h) {
    return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        return p ? { url: p.url, title: p.title, price: p.price, available: p.available, featured_image: p.featured_image } : null;
      })
      .catch(function () { return null; });
  }

  /* ---------- 1. Floating cart ---------- */
  function floatingCart() {
    if (template === 'cart') return;
    var hdrCart = document.querySelector('.px-hdr__cart');
    if (!hdrCart) return;
    var hdrCount = hdrCart.querySelector('.px-hdr__count');

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'px-fcart';
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.6 11.2a2 2 0 002 1.6h7.7a2 2 0 002-1.5L21 8H6"/><circle cx="10" cy="20" r="1.2"/><circle cx="18" cy="20" r="1.2"/></svg><span class="px-fcart__n" hidden></span>';
    var n = b.querySelector('.px-fcart__n');
    document.body.appendChild(b);

    function syncCount() {
      var c = hdrCount ? parseInt((hdrCount.textContent || '0').trim(), 10) || 0 : 0;
      if (hdrCount && hdrCount.style.display === 'none') c = 0;
      n.textContent = c;
      n.hidden = c === 0;
      b.setAttribute('aria-label', L.cart + ': ' + c);
    }
    syncCount();
    if (hdrCount && window.MutationObserver) {
      new MutationObserver(syncCount).observe(hdrCount, { childList: true, characterData: true, subtree: true, attributes: true });
    }

    b.addEventListener('click', function () { hdrCart.click(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        b.classList.toggle('is-on', !visible);
        b.tabIndex = visible ? -1 : 0;
      }).observe(hdrCart);
    } else {
      b.classList.add('is-on');
    }
  }

  /* Lift floating buttons above the mobile product buy bar */
  function buybarLift() {
    var bar = document.querySelector('.px-buybar');
    if (!bar) return;
    function check() {
      var cs = getComputedStyle(bar);
      var on = cs.display !== 'none' && cs.visibility !== 'hidden' && (cs.position === 'fixed' || cs.position === 'sticky');
      document.documentElement.classList.toggle('px-has-buybar', on);
    }
    check();
    window.addEventListener('resize', check);
  }

  /* ---------- 4. Low stock (real inventory, 5 or fewer) ---------- */
  function lowStock() {
    var dataEl = document.getElementById('pxStockData');
    var stockEl = document.querySelector('.px-pdp__stock');
    var idInput = document.querySelector('.px-pdp input[id^="pxVariantId-"]');
    if (!dataEl || !stockEl || !idInput) return;
    var stock;
    try { stock = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var line = document.createElement('p');
    line.className = 'px-lowstock';
    line.hidden = true;
    stockEl.parentNode.insertBefore(line, stockEl.nextSibling);

    function update() {
      var q = stock[String(idInput.value)];
      if (typeof q === 'number' && q > 0 && q <= 5) {
        line.textContent = q === 1 ? L.low1 : L.low.replace('{n}', q);
        line.hidden = false;
      } else {
        line.hidden = true;
        line.textContent = '';
      }
    }
    update();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-px-option]')) setTimeout(update, 0);
    });
  }

  /* shared card builder - same markup as the Related products part */
  function cards(list, title, extraClass) {
    var html = '<section class="px-wrap px-rel ' + extraClass + '"><h2 class="px-rel__h">' + esc(title) + '</h2><ul class="px-rel__grid">';
    list.forEach(function (p) {
      var src = p.featured_image && (p.featured_image.src || p.featured_image);
      html += '<li class="px-rel__item"><a class="px-rel__link" href="' + esc(p.url) + '">' +
        '<span class="px-rel__media">' + (src ? '<img class="px-rel__img" loading="lazy" src="' + esc(img(src, 600)) + '" alt="' + esc(p.title) + '">' : '') + '</span>' +
        '<h3 class="px-rel__title">' + esc(p.title) + '</h3>' +
        (p.price > 0 ? '<span class="px-rel__price' + (p.available ? '' : ' px-rel__price--out') + '">' + esc(money(p.price)) + '</span>' : '') +
        '</a></li>';
    });
    html += '</ul></section>';
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    return wrap.firstChild;
  }

  /* ---------- 7. Goes well with (product field "Goes well with", pullorax.complementary) ---------- */
  /* 16 Oct 2026 (owner-approved): the row also brings in the rest of the product's own set (same
     set code - pack, box, case; boxes first), looked up by sections/pullorax-same-set.liquid, so every
     product reaches its set even where nobody pinned it by hand. The pinned products follow. */
  function sameSet() {
    var code = (ds.setCode || '').trim();
    if (!code) return Promise.resolve([]);
    var url = root + 'search?q=' + encodeURIComponent(code) + '&type=product&options%5Bprefix%5D=last&section_id=pullorax-same-set';
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = /<script[^>]*data-px-sameset[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
      if (!m) return [];
      try { return JSON.parse(m[1]) || []; } catch (e) { return []; }
    }).catch(function () { return []; });
  }
  function complementary() {
    var grid = document.querySelector('.px-pdp .px-pdp__grid');
    if (!grid) return;
    var own = ds.productHandle || '';
    var pinned = (ds.cmp || '').split(',').filter(Boolean);
    sameSet().then(function (set) {
      var seen = {}, handles = [];
      set.concat(pinned).forEach(function (h) { if (h && h !== own && !seen[h]) { seen[h] = 1; handles.push(h); } });
      handles = handles.slice(0, 4);
      if (!handles.length) return;
      return Promise.all(handles.map(fetchProduct)).then(function (res) {
        var items = res.filter(function (p) { return p && p.available; });
        if (!items.length) return;
        /* A sold-out product shows its in-stock alternatives first (sections/pullorax-product.liquid). */
        var after = document.querySelector('.px-pdp .px-soldalt') || grid;
        var sec = cards(items, L.cmp, 'px-cmp');
        /* 16 Oct 2026 (owner): on a box with the buy-together block, the cards join that same part under it. */
        var bt3 = document.querySelector('.px-pdp .px-bt3');
        if (bt3) {
          var shown = {};
          [].forEach.call(bt3.querySelectorAll('a.px-bt3__link'), function (a) { shown[a.pathname.replace(/^.*\/products\//, '')] = 1; });
          items = items.filter(function (p) { return !shown[String(p.url).replace(/^.*\/products\//, '').split('?')[0]]; });
          if (!items.length) return;
          bt3.appendChild(cards(items, L.cmp, 'px-cmp').querySelector('.px-rel__grid'));
          return;
        }
        after.parentNode.insertBefore(sec, after.nextSibling);
      });
    });
  }

  /* ---------- 2. Recently viewed ---------- */
  var RV_KEY = 'pxRecentlyViewed';
  function recentlyViewed() {
    var handle = ds.productHandle;
    if (!handle) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    var show = list.filter(function (h) { return h !== handle; }).slice(0, 4);
    try {
      localStorage.setItem(RV_KEY, JSON.stringify([handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12)));
    } catch (e) {}
    if (!show.length) return;
    var pdp = document.querySelector('.px-pdp');
    if (!pdp) return;
    var anchor = pdp.querySelector('.px-buybar');
    Promise.all(show.map(fetchProduct)).then(function (res) {
      var items = res.filter(Boolean);
      if (!items.length) return;
      var sec = cards(items, L.rv, 'px-rv');
      if (anchor) pdp.insertBefore(sec, anchor); else pdp.appendChild(sec);
    });
  }

  /* 16 Oct 2026 (owner-approved): an empty cart page shows the products viewed last (in stock only). */
  function emptyCartRecent() {
    var slot = document.querySelector('[data-px-empty-rv]');
    if (!slot) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list) || !list.length) return;
    Promise.all(list.slice(0, 8).map(fetchProduct)).then(function (res) {
      var items = res.filter(function (p) { return p && p.available; }).slice(0, 4);
      if (items.length) slot.appendChild(cards(items, L.rv, 'px-rv'));
    });
  }

  function init() {
    floatingCart();
    buybarLift();
    emptyCartRecent();
    if (template === 'product') {
      lowStock();
      complementary();
      recentlyViewed();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
